<!-- 地图 -->
<style lang="stylus" scoped>
.center {
  height: 786px;
  padding: 5px;
  background-size: 100% 100%;
  text-align: center;

  .top {
    display: flex;
    padding-left: 46px;
    box-sizing: border-box;
    color: #fff;
    font-size: 22px;

    .item {
      width: 366px;
      height: 60px;
      line-height: 60px;
      margin-right: 45px;
      background: url('../../../../static/img/recordInformation/1.png') no-repeat;

      span {
        padding: 0 40px;
      }

      span:nth-child(1) {
        border-right: 1px solid #125BE0;
      }
    }
  }

  .bottom {
    margin-top: 25px;
    width: 1350px;
    height: 816px;
    margin-left: 16px;
    position: relative;
    display: flex;
    justify-content: space-around;

    .img {
      position: absolute;
      z-index: 10;
    }

    .img1 {
      top: 80px;
      left: 80px;
    }

    .img2 {
      top: 100px;
      left: 600px;
    }

    .img3 {
      top: 300px;
      left: 300px;
    }

    .img4 {
      top: 1200px;
      left: 100px;
    }

    .img5 {
      top: 200px;
      left: 80px;
    }

    .img6 {
      top: 150px;
      left: 110px;
    }

    .base-detail {
      width: 328px;
      height: 238px;
      position: absolute;
      z-index: 10;
      background: rgba(0, 36, 90, 1);
      border: 1px solid rgba(73, 117, 233, 1);
      opacity: 0.7;
      top: 100px;
      left: 400px;
      color: #fff;
      font-size: 20px;
      padding: 18px 24px;
      box-sizing: border-box;

      .tit {
        text-align: center;
        margin-bottom: 20px;
      }

      .detail-item {
        display: flex;
        line-height: 36px;

        img {
          width: 20px;
          height: 24px;
          margin-right: 30px;
          margin-top: 6px;
        }

        .img1 {
          width: 24px;
        }

        .img2 {
          width: 22px;
        }
      }
    }

    .map-container {
      width: 840px;
      height: 816px;
      padding: 40px 32px;
      box-sizing: border-box;
      background: url('../../../../static/img/recordInformation/2.png') no-repeat;

      .map {
        width: 776px;
        height: 734px;
      }
    }

    .list {
      margin-top: 55px;
      display: flex;

      .list-item {
        display: flex;
        width: 50%;
        text-align: center;

        .point {
          width: 10px;
          height: 10px;
          background: rgba(61, 166, 255, 1);
          border-radius: 50%;
          margin-top: 3px;
          margin-right: 5px;
        }

        .name {
          font-size: 16px;
          color: rgba(176, 219, 255, 1);
        }
      }
    }

    .detail {
      height: 814px;
      width: 460px;
      background: url('../../../../static/img/recordInformation/5.png') no-repeat;
      background-position: 0px;
      color: #fff;
      padding: 15px 22px 0;
      box-sizing: border-box;

      .tit {
        font-size: 28px;
        text-align: center;
      }

      .list1 {
        margin-top: 20px;
        text-align: left;

        .list-item {
          display: flex;
          line-height: 60px;
          flex-wrap: wrap;

          img {
            margin-right: 30px;
            width: 24px;
            height: 20px;
            margin-top: 24px;
          }

          .img1 {
            width: 20px;
            height: 24px;
          }

          .img2 {
            height: 24px;
          }

          .img3 {
            width: 22px;
            height: 24px;
          }
        }

        .msg {
          width: 320px;
          font-size: 20px;
          border-bottom: 1px solid #0092EE;
        }

        .list-item1 {
          .msg {
            border-bottom: none;
          }

          .trace-pro {
            margin-left: 54px;

            img {
              width: 100px;
              height: 90px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div>
    <div class="center">
      <div class="top">
        <div class="item">
          <span>入网企业</span>
          <span>201个</span>
        </div>
        <div class="item">
          <span>智能硬件设备个数</span>
          <span>40个</span>
        </div>
        <div class="item">
          <span>追溯产品</span>
          <span>71种</span>
        </div>
      </div>

      <div class="bottom">
        <!-- <img class="img img1" src="../../../../static/img/recordInformation/base.png" alt>
        <img class="img img2" src="../../../../static/img/recordInformation/base.png" alt>
        <img class="img img3" src="../../../../static/img/recordInformation/base.png" alt>
        <img class="img img4" src="../../../../static/img/recordInformation/monitor.png" alt>
        <img class="img img5" src="../../../../static/img/recordInformation/weather.png" alt>
        <img class="img img6" src="../../../../static/img/recordInformation/company.png" alt> -->

        <div class="base-detail" id="detail" :style="detailStyle">
          <p class="tit">基地详情</p>
          <div class="detail-item">
            <img src="../../../../static/img/recordInformation/16.png" alt>
            <div class="msg">{{positionItem.name}}</div>
          </div>
          <div class="detail-item">
            <img class="img1" src="../../../../static/img/recordInformation/13.png" alt>
            <div class="msg">{{positionItem.address}}</div>
          </div>
          <div class="detail-item">
            <img class="img2" src="../../../../static/img/recordInformation/14.png" alt>
            <div class="msg">{{positionItem.manager}}</div>
          </div>
          <div class="detail-item">
            <img class="img1" src="../../../../static/img/recordInformation/15.png" alt>
            <div class="msg">{{positionItem.year}}</div>
          </div>
        </div>

        <div class="map-container">
          <el-amap vid="amapDemo" ref="map" :zoom="zoom" :center="center" class="map" :plugin="plugin" :amap-manager="amapManager" :events="events"></el-amap>
        </div>

        <div class="detail">
          <p class="tit">企业信息介绍</p>
          <div class="list1">
            <div class="list-item">
              <img src="../../../../static/img/recordInformation/11.png" alt>
              <div class="msg">{{positionItem1.name}}</div>
            </div>
            <div class="list-item">
              <img class="img1" src="../../../../static/img/recordInformation/12.png" alt>
              <div class="msg">{{positionItem1.address}}</div>
            </div>
            <div class="list-item">
              <img class="img2" src="../../../../static/img/recordInformation/6.png" alt>
              <div class="msg">{{positionItem1.phone}}</div>
            </div>
            <div class="list-item list-item1">
              <img class="img3" src="../../../../static/img/recordInformation/7.png" alt>
              <div class="msg">可追溯商品 12 种</div>
              <div class="trace-pro">
                <img src="../../../../static/img/recordInformation/pic1.png" alt>
                <img src="../../../../static/img/recordInformation/pic2.png" alt>
                <img src="../../../../static/img/recordInformation/pic3.png" alt>
              </div>
            </div>
            <div class="list-item">
              <img class="img2" src="../../../../static/img/recordInformation/10.png" alt>
              <div class="msg">溯源基地 2 个</div>
            </div>
            <div class="list-item">
              <img src="../../../../static/img/recordInformation/8.png" alt>
              <div class="msg">气象设备2台</div>
            </div>
            <div class="list-item">
              <img class="img1" src="../../../../static/img/recordInformation/9.png" alt>
              <div class="msg">监控设备14台</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseIcon from '../../../../static/img/recordInformation/base.png'
import monitorIcon from '../../../../static/img/recordInformation/monitor.png'
import weatherIcon from '../../../../static/img/recordInformation/weather.png'
import companyIcon from '../../../../static/img/recordInformation/company.png'
import Vue from 'vue'
import VueAMap from 'src/amap.js';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.CircleEditor', 'AMap.MouseTool']
});
let amapManager = new VueAMap.AMapManager();
const markers = [
  { point: [107.00836, 23.773378], src: baseIcon },
  { point: [106.897124, 23.676572], src: baseIcon },
  { point: [106.713103, 23.66651], src: baseIcon },
  { point: [106.825712, 23.797255], src: monitorIcon },
  { point: [107.130583, 23.836201], src: monitorIcon },
  { point: [106.855925, 23.667767], src: monitorIcon },
  { point: [106.941069, 23.753269], src: weatherIcon },
  { point: [107.12921, 23.723098], src: weatherIcon },
  { point: [106.983641, 23.622479], src: companyIcon },
  { point: [106.942442, 23.696693], src: companyIcon },
  { point: [106.994627, 23.602346], src: companyIcon }
];
export default {
  data() {
    return {
      positionTimes: 0,
      amapManager,
      zoom: 12,
      center: [106.9156629745, 23.7356699750],
      plugin: [],
      events: {
        init: o => {
          this.map = this.$refs.map.$$getInstance();
          const AMap = window.AMap;
        },
        complete: o => {
          var RoadNet = new AMap.TileLayer.Satellite();
          this.map.add([RoadNet]);
          // 标记点
          for (let i in markers) {
            const icon = new AMap.Icon({
              size: new AMap.Size(50, 50),
              imageSize: new AMap.Size(50, 50),
              image: markers[i].src
            });
            const marker = new AMap.Marker({
              position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
              cursor: 'pointer',
              icon: icon,
              extData: markers[i]
            });
            marker.on('click', function () {
              console.log(marker.getExtData())
            });
            this.map.add(marker);
          }
        }
      },
      positionList: [
        { top: 100, left: 450, name: '广西省百色市', address: '百色市芒果生产基地', manager: '李大力', year: '10年' },
        { top: 150, left: 150, name: '广西省百色市', address: '百色市圣女果生产基地', manager: '张明', year: '3年' },
        { top: 100, left: 400, name: '广西省百色市', address: '百色市牛心李生产基地', manager: '王玉', year: '6年' }],
      detailList: [
        { name: '广西田阳天穗农产品贸易有限公司', address: '广西省百色市', phone: '88383928' },
        { name: '广西百色盛泰和农业有限公司', address: '广西省百色市', phone: '88383928' },
        { name: '田阳县蔬心特色农产品经营部', address: '广西省百色市', phone: '88383928' }
      ]
    }
  },
  components: {
  },
  computed: {
    positionItem() {
      return this.positionList[this.positionTimes % this.positionList.length]
    },
    positionItem1() {
      return this.detailList[this.positionTimes % this.detailList.length]
    },
    detailStyle() {
      const len = this.positionList.length
      return `top:${this.positionList[this.positionTimes % len].top}px;left:${this.positionList[this.positionTimes % len].left}px`
    }
  },
  methods: {
    changeSwiper: function () {
      const that = this
      setTimeout(function () {
        that.positionTimes++
        that.changeSwiper()
      }, 3000)
    }
  },
  mounted() {
    this.changeSwiper()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?5313964d